window.onload = () => {
  
  var tryon_btn =  document.getElementById('tryon-btn');
  if (tryon_btn)
  {
       
    
  var modal = document.getElementById("try-on-popup");
  var span = document.getElementsByClassName("close1")[0];

  document.getElementById('tryon-btn').addEventListener('click', () => {
   if (current_product_gender || current_product_size){
       document.getElementById("fittingbox-feature").style.display = "none";
       document.getElementById("fitmix-container").style.display = "block";
       document.getElementById("modal-footer1").style.display = "block";
       document.getElementById("ipd").style.display = "block";
       modal.style.display = "block";
  }
    else
    {
       document.getElementById("fittingbox-feature").style.display = "block";
       document.getElementById("fitmix-container").style.display = "none";
       document.getElementById("modal-footer1").style.display = "none";
       document.getElementById("ipd").style.display = "none";
      modal.style.display = "block";
    }
    
    
      if (product_variant_sku =='')
       {
       fitmixInstance.setFrame(current_product_variant_sku);
       document.getElementById("current_product_variant_title").innerHTML = '  '+current_product_variant_title;
        }
       else
       {
       fitmixInstance.setFrame(product_variant_sku);
       document.getElementById("current_product_variant_title").innerHTML = '  '+ product_variant_title;
       }

    //
    
    if (current_product_gender) {
        fitmixInstance.setUserInfo({ gender: current_product_gender });
    }
    if (current_product_size) {
        fitmixInstance.setPupillaryDistance(parseInt(current_product_size));
    }
    //    
   
    });
  ////// open fittinbox features
   document.getElementById('ipd').addEventListener('click', () => {
      document.getElementById("fittingbox-feature").style.display = "block";
      document.getElementById("fitmix-container").style.display = "none";
      document.getElementById("modal-footer1").style.display = "none";
      document.getElementById("ipd").style.display = "none";
       document.getElementById("img01").style.display = "none";
    
    });  
  
  
 ///////// set user info woman/man/size begin 
  document.getElementById('fittinbox-woman').addEventListener('click', () => {
      document.getElementById("fittingbox-feature").style.display = "none";
      document.getElementById("fitmix-container").style.display = "block";
      document.getElementById("modal-footer1").style.display = "block";
      document.getElementById("ipd").style.display = "block";
      //fitmixInstance.setUserInfo({gender: 'f'});
      //current_product_gender='f'
      $.cookie("product_gender", 'f',{path:'/',secure:true }); //$.removeCookie("test");
      current_product_gender = $.cookie('product_gender');
      fitmixInstance.setUserInfo({ gender: current_product_gender });    
   
    });  

  document.getElementById('fittinbox-man').addEventListener('click', () => {
      document.getElementById("fittingbox-feature").style.display = "none";
      document.getElementById("fitmix-container").style.display = "block";
      document.getElementById("modal-footer1").style.display = "block";
      document.getElementById("ipd").style.display = "block";
      //fitmixInstance.setUserInfo({gender: 'm'});
      //current_product_gender='m'
     $.cookie("product_gender", 'm',{path:'/',secure:true });
     current_product_gender = $.cookie('product_gender');
     fitmixInstance.setUserInfo({ gender: current_product_gender });
    });


  document.getElementById('selectsize').addEventListener('change', (event) => {
      document.getElementById("fittingbox-feature").style.display = "none";
      document.getElementById("fitmix-container").style.display = "block";
      document.getElementById("modal-footer1").style.display = "block";
      document.getElementById("ipd").style.display = "block";
      //current_product_size=event.target.value;
      //fitmixInstance.setPupillaryDistance(parseInt(current_product_size));
      $.cookie("product_size", event.target.value,{path :'/',secure:true });
      current_product_size = $.cookie('product_size');
      fitmixInstance.setPupillaryDistance(parseInt(current_product_size));
   
    }); 


  document.getElementById('fittinbox-help').addEventListener('click', (event) => {
    event.preventDefault();
    document.getElementById("fittingbox-feature").style.display = "none";
     var modalImg = document.getElementById("img01");
     modalImg.src = this.href;
     document.getElementById("img01").style.display = "block";
    document.getElementById("ipd").style.display = "block";
    return false;
    }); 
  
/////// set user info woman/man/size end

 span.onclick = function() {
   //fitmixInstance.resetSession();
   modal.style.display = "none";
   document.getElementById("img01").style.display = "none"; //vto info image
   
  }
 
// document.getElementById('remove_frame').onclick = function() {
   //fitmixInstance.remove()
  // modal.style.display = "none";
 // }

    //
    loadFitMix();
    if (current_product_gender) {
        //fitmixInstance.setUserInfo({ gender: current_product_gender });
    }
    if (current_product_size) {
        //fitmixInstance.setPupillaryDistance(parseInt(current_product_size));
    }
    //
    

     if (typeof current_product_variant_sku !== 'undefined') {
       if (current_product_variant_sku =='')
         {
          document.getElementById('tryon-btn').style.display = 'none';
         }
        else
          
         {
            document.getElementById('tryon-btn').style.display = 'block';
           //if(no_lens.includes(current_product_variant_sku))
          // {
            // document.getElementById('tryon-btn').style.display = 'none';
             
          // }
          // else
          // {
         // document.getElementById('tryon-btn').style.display = 'block';
          //fitmixInstance.setFrame(current_product_variant_sku);
            
           //}
         }
      }
  
  }
///////// ritch text section try on
 
   var current_collection_product_variant_sku='';
  var section_ritch_text = document.getElementById('shopify-section-template--17337679282327__16559902376eb13af2');
 if (section_ritch_text)
 {
  var section_links =  section_ritch_text.getElementsByTagName('a');
   
   if (section_links)
   {
   
   var collection_tryon_btn = section_links[0];
     ///
     if (collection_tryon_btn){
       
        var collection_modal = document.getElementById("collection-try-on-popup");
        var collection_span = document.getElementsByClassName("close1")[0];
       
       collection_tryon_btn.addEventListener('click', () => {
                                            
      // document.getElementById("fittingbox-feature1").style.display = "none";
      // document.getElementById("fitmix-container1").style.display = "block";
      // document.getElementById("modal-footer1").style.display = "block";
      // document.getElementById("ipd").style.display = "block";
      // collection_modal.style.display = "block"; 
            ///////////////////////
   if (current_collection_product_gender || current_collection_product_size){
       document.getElementById("fittingbox-feature").style.display = "none";
       document.getElementById("fitmix-container1").style.display = "block";
       document.getElementById("modal-footer1").style.display = "block";
       document.getElementById("ipd").style.display = "block";
       collection_modal.style.display = "block";
  }
    else
    {
       document.getElementById("fittingbox-feature").style.display = "block";
       document.getElementById("fitmix-container1").style.display = "none";
       document.getElementById("modal-footer1").style.display = "none";
       document.getElementById("ipd").style.display = "none";
       collection_modal.style.display = "block";
    }

////////////////////////                                    
       
       /////////////////////////////////
       

        rmslide=document.getElementById('rmslide');

 if (rmslide)
 {
 var active_slide = rmslide.getElementsByClassName('thumb-active');  //getElementsByTagName('a'); 
   
   if (active_slide)
     
   { 
    var current_active_slide = active_slide[0]; 
     
      if (current_active_slide){
      
         current_collection_product_variant_sku= current_active_slide.getAttribute("data-image-sku");
        //fitmixInstance1.resumeStream();
        
         fitmixInstance1.setFrame(current_collection_product_variant_sku);
          
        //console.log('fist_slide_attribute_sku:'+current_collection_product_variant_sku);
      } //end if current_active_slide
     
   } //end if active_slide
   
 }// end if rmslide
 
 /////////////////////
    //    
     if (current_collection_product_gender) {
          fitmixInstance1.setUserInfo({ gender: current_collection_product_gender });
     }
     if (current_collection_product_size) {
         fitmixInstance1.setPupillaryDistance(parseInt(current_collection_product_size));
      }
      //
     
     }); //end  collection_tryon_btn.addEventListener click  
     
      collection_span.onclick = function() {
   //fitmixInstance1.stopVto();
   collection_modal.style.display = "none";
   document.getElementById("img01").style.display = "none"; //vto info image
   
  } //end collection_span click
      
     //
    loadFitMix1();
     if (current_collection_product_gender) {
          //fitmixInstance1.setUserInfo({ gender: current_collection_product_gender });
     }
     if (current_collection_product_size) {
        // fitmixInstance1.setPupillaryDistance(parseInt(current_collection_product_size));
      }
      //
      
       
     }
     /// end if collection_tryon_btn
       
       }
//////////////////////////////////////

   document.getElementById('ipd').addEventListener('click', () => {
      document.getElementById("fittingbox-feature").style.display = "block";
      document.getElementById("fitmix-container1").style.display = "none";
      document.getElementById("modal-footer1").style.display = "none";
      document.getElementById("ipd").style.display = "none";
       document.getElementById("img01").style.display = "none";
    
    });  
  
  
 ///////// set user info woman/man/size begin 
  document.getElementById('fittinbox-woman').addEventListener('click', () => {
      document.getElementById("fittingbox-feature").style.display = "none";
      document.getElementById("fitmix-container1").style.display = "block";
      document.getElementById("modal-footer1").style.display = "block";
      document.getElementById("ipd").style.display = "block";
      //fitmixInstance1.setUserInfo({gender: 'f'});
      //current_collection_product_gender='f';
      $.cookie("product_gender", 'f',{path :'/',secure:true});
      current_collection_product_gender = $.cookie('product_gender');
      fitmixInstance1.setUserInfo({ gender: current_collection_product_gender });    
      
   
    });  

  document.getElementById('fittinbox-man').addEventListener('click', () => {
      document.getElementById("fittingbox-feature").style.display = "none";
      document.getElementById("fitmix-container1").style.display = "block";
      document.getElementById("modal-footer1").style.display = "block";
      document.getElementById("ipd").style.display = "block";
      //fitmixInstance1.setUserInfo({gender: 'm'});
      //current_collection_product_gender='m';
      $.cookie("product_gender", 'm',{path :'/',secure:true});
      current_collection_product_gender = $.cookie('product_gender');
      fitmixInstance1.setUserInfo({ gender: current_collection_product_gender });
    });


  document.getElementById('selectsize').addEventListener('change', (event) => {
      document.getElementById("fittingbox-feature").style.display = "none";
      document.getElementById("fitmix-container1").style.display = "block";
      document.getElementById("modal-footer1").style.display = "block";
      document.getElementById("ipd").style.display = "block";
      //current_collection_product_size=event.target.value;
      //fitmixInstance1.setPupillaryDistance(parseInt(current_collection_product_size));
      $.cookie("product_size", event.target.value,{path :'/',secure:true});
      current_collection_product_size = $.cookie('product_size');
      fitmixInstance1.setPupillaryDistance(parseInt(current_collection_product_size));
   
    }); 


  document.getElementById('fittinbox-help').addEventListener('click', (event) => {
    event.preventDefault();
    document.getElementById("fittingbox-feature").style.display = "none";
     var modalImg = document.getElementById("img01");
     modalImg.src = this.href;
     document.getElementById("img01").style.display = "block";
    document.getElementById("ipd").style.display = "block";
    return false;
    }); 

//////////////////////////////////

      window.onclick = function(event) {
  if (event.target == document.getElementById("collection-try-on-popup")) {
   document.getElementById("collection-try-on-popup").style.display = "none";
   document.getElementById("img01").style.display = "none"; //vto info image
   document.getElementById("fittingbox-feature").style.display = "block";
  }
      }
      
  window.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    document.getElementById("collection-try-on-popup").style.display = 'none';
    document.getElementById("img01").style.display = "none"; //vto info image
    document.getElementById("fittingbox-feature").style.display = "block";
  }
}) 

   ///////////////////////
var myFunction1 = function() { 
 
 var attribute_sku1= this.getAttribute("data-image-sku");
  
  fitmixInstance1.setFrame(attribute_sku1);
  
  };
var thumb_active1 = document.getElementsByClassName("thumb-active1");
for (var i = 0; i < thumb_active1.length; i++) {
 
  thumb_active1[i].addEventListener('click', myFunction1, false);
  
  } 

////////////////////////

 }//end if section_ritch_text

};

